import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Input, Label, Row,} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { confirmAlert } from 'react-confirm-alert';

import { ButtonClean, ButtonSearch, ButtonTableDelete, ButtonTableEdit, ButtonTableFilter } from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { useForm } from "react-hook-form";
import { utilHelper } from "../../../jwt/_helpers";
import { phoneCodeService } from "../../../jwt/_services/hotel/phoneCodeService";
import { ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, deleteErrorMsg, deleteMsg, error, LIST, NO, warning, YES } from "../../../components/i18n/i18n";

export default function PhoneCodeList(props) {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    // FILTERS
    const [collapsed, setCollapsed] = useState(true);
    const [filters, setFilters] = useState({
        code : null,
        name : null,
        iso  : null,
        iso2 : null
    })

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage, filters);
    }, []);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filters?.code,
            name: filters?.name,
            iso: filters?.iso,
            iso2: filters?.iso2
        }
    });

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage;
        refreshDataList(page, index, sizePerPage, filters);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, _filters) => {
        setLoading(true);

        phoneCodeService.search(currentIndex, sizePerPage, _filters)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);

        phoneCodeService.deleteItem(data.id, fbDataBaseId)
            .then(_ => refreshDataList(page, currentIndex, sizePerPage, filters))
            .finally(() => setLoading(false));
    }

    const onSubmit = (data, _) => {
        const dataRequest = {
            code : data.code,
            name : data.name,
            iso  : data.iso,
            iso2 : data.iso2,
        };
        setFilters(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest);
    };


    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, 'FORM');
    }

    const showFilters = () => setCollapsed(!collapsed);

    const cleanFields = () => {
        setFilters({
            code: null,
            name: null,
            iso: null,
            iso2: null
        });
        reset();
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => <div className="float-left">
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
        <ButtonTableEdit onClick={() => editItem(row)}/>
    </div>

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'idCode',
            headerStyle: {width: '80px'},
            text: "Id",
        }, {
            dataField: 'name',
            text: 'Nombre'
        }, {
            dataField: 'code',
            text: 'Código',
        }, {
            dataField: 'iso',
            headerStyle: {width: '120px'},
            text: 'ISO',
        }, {
            dataField: 'iso2',
            headerStyle: { width: '120px' },
            text: 'ISO (2 char)',
        }, {
            align: 'center',
            dataField: 'actions',
            headerAlign: 'center',
            headerStyle: { width: '140px' },
            isDummyField: true,
            text: 'Acción',
            formatter: actionsFormatter
        }
    ];

    return (
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Codigo</Label>
                                        <Input type="text" name="code"
                                               placeholder="Búsqueda por código."
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Nombre</Label>
                                        <Input type="text" name="name"
                                               placeholder="Búsqueda por nombre."
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>ISO</Label>
                                        <Input type="text" name="iso"
                                               placeholder="Búsqueda por iso."
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>ISO (2 caracteres)</Label>
                                        <Input type="text" name="iso2"
                                               placeholder="Búsqueda por iso2."
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <div className="float-right d-flex justify-content-lg-end">
                                        <ButtonSearch/>
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>

                </Collapse>
                <CardBody className="">
                    {loading && showLoader()}
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        pagination={paginationFactory({page, sizePerPage, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
    )
}